<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-select
                    v-model="queryParam.commId"
                    clearable
                    filterable
                    placeholder="请选择小区"
                >
                    <el-option
                        v-for="item in optionList"
                        :key="item.commId"
                        :label="item.commName"
                        :value="item.commId"
                    />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.name"
                    size="mini"
                    clearable
                    placeholder="车牌号"
                />
            </div>
            <div class="shaixuan-item">
                <el-select
                    v-model="queryParam.status"
                    clearable
                    placeholder="状态"
                >
                    <el-option label="上架" :value="1" />
                    <el-option label="下架" :value="0" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.desc"
                    size="mini"
                    clearable
                    placeholder="描述"
                />
            </div>
            <div class="shaixuan-item">
                <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button>
                <el-button
                    @click="resetSearch()"
                    icon="el-icon-refresh"
                >
                    重置
                </el-button>
                <el-button
                    @click="clickItem(0)"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    新增
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
                stripe
            >
                <el-table-column prop="id" label="ID" width="80" align="center" />
                <el-table-column label="小区" width="140" align="center">
                    <template slot-scope="scope">
                        {{ (scope.row.community && scope.row.community.commName) || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="车牌号" width="150" align="center" />
                <el-table-column prop="che_xing" label="车型" width="120" align="center" show-overflow-tooltip />
                <el-table-column prop="yanse" label="颜色" width="100" align="center" />
                <el-table-column prop="chejiahao" label="车架号" width="180" align="center" show-overflow-tooltip />
                <el-table-column prop="desc" label="描述" width="200" align="center" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            class="drawer-switch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                            @change="changeStatus(scope.row)"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="封面图" width="120" align="center">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.thumb"
                            :src="scope.row.thumb"
                            :preview-src-list="[scope.row.thumb]"
                            style="width: 50px; height: 50px;"
                            fit="cover"
                        />
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" minWidth="280">
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button
                                type="primary"
                                size="mini"
                                @click="clickItem(1, scope.row)"
                                icon="el-icon-edit"
                            >
                                编辑
                            </el-button>
                            <!-- <el-button
                                type="warning"
                                size="mini"
                                @click="openCalendarDrawer(scope.row)"
                                icon="el-icon-copy-document"    
                            >日历</el-button> -->
                            <el-button
                                type="danger"
                                size="mini"
                                @click="remove(scope.row)"
                                icon="el-icon-delete"
                            >
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="500px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <div class="add-danwei">
                    <el-form
                        ref="ruleForm"
                        :model="viewData"
                        :rules="rules"
                        label-width="100px"
                    >
                        <el-form-item label="小区" prop="commId">
                            <el-select
                                v-model="viewData.commId"
                                clearable
                                filterable
                                placeholder="请选择小区"
                            >
                                <el-option
                                    v-for="item in optionList"
                                    :key="item.commId"
                                    :label="item.commName"
                                    :value="item.commId"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="车牌" prop="name">
                            <el-input v-model="viewData.name" placeholder="请输入车牌号" />
                        </el-form-item>
                        <el-form-item label="车型" prop="che_xing">
                            <el-input v-model="viewData.che_xing" placeholder="请输入车型" />
                        </el-form-item>
                        <el-form-item label="颜色" prop="yanse">
                            <el-input v-model="viewData.yanse" placeholder="请输入颜色" />
                        </el-form-item>
                        <el-form-item label="车架号" prop="chejiahao">
                            <el-input v-model="viewData.chejiahao" placeholder="请输入车架号" />
                        </el-form-item>
                        <el-form-item label="封面图" prop="thumb">
                          <image-upload ref="imageUpload"
                                        v-if="showUpload"
                                        :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸180*120，请自己处理好宽高比例`"
                                        :image-list="imageDefaultList"
                                        :autoCropWidth="180"
                                        :autoCropHeight="120"
                                        :maxNumber="1"
                                        @updateImg="onUpdateImg($event)"></image-upload>
                        </el-form-item>
                        <el-form-item label="描述" prop="desc">
                            <el-input v-model="viewData.desc" type="textarea" placeholder="请输入描述" />
                        </el-form-item>
                        <!-- <el-form-item label="内容" prop="content">
                            <vue-ueditor-wrap ref="ueditor" v-model="viewData.content" :config="ueconfig"></vue-ueditor-wrap>
                        </el-form-item> -->
                        <el-form-item label="状态" prop="status">
                            <el-switch
                                v-model="viewData.status"
                                class="drawer-switch"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="1"
                                :inactive-value="0"
                            />
                        </el-form-item>
                    </el-form>
                    <div class="fix-fotter">
                        <el-button
                            style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                            size="mini"
                            type="primary"
                            @click="tijiao('ruleForm')"
                        >
                            提交
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 日历抽屉 -->
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showCalendarDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="800px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">车辆预约日历 - {{ currentCar ? currentCar.name : '' }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeCalendarDrawer" />
                </div>
            </template>
            <div class="custom-content">
                <div class="calendar-container">
                    <div class="calendar-header">
                        <el-button @click="prevMonth" icon="el-icon-arrow-left">上个月</el-button>
                        <span class="current-month">{{ currentMonth.getFullYear() }}年{{ currentMonth.getMonth() + 1 }}月</span>
                        <el-button @click="nextMonth" icon="el-icon-arrow-right">下个月</el-button>
                    </div>
                    <!-- 自定义日期单元格:calendarData有数据时显示已预约，无数据时显示可预约，今天之前的日期有数据的显示已预约，无数据的显示不可预约 -->
                    <el-calendar v-model="currentMonth">
                        <template slot="dateCell" slot-scope="{date, data}">
                            <el-tooltip
                                effect="dark"
                                placement="top"
                                popper-class="calendar-booked-tooltip"
                                :disabled="!isBooked(data.day)"
                            >
                                <div slot="content" class="calendar-booked-tooltip-content">
                                    <div>姓名：{{ getBookedName(data.day) }}</div>
                                    <div>手机号：{{ getBookedPhone(data.day) }}</div>
                                    <div>备注：{{ getBookedRemark(data.day) }}</div>
                                </div>
                                <div
                                    class="calendar-day"
                                    :class="{ 'calendar-day-clickable': isAvailableDay(data.day, data) }"
                                    @click.stop="handleDayCellClick(data)"
                                >
                                    <p>{{ data.day.split('-').slice(2).join('-') }}</p>
                                    <template v-if="isCurrentMonthCell(data)">
                                        <div v-if="isBooked(data.day)" class="booked">已预约</div>
                                        <div v-else-if="isUnavailableDay(data.day, data)" class="unavailable">不可预约</div>
                                        <div v-else class="available">可预约</div>
                                    </template>
                                </div>
                            </el-tooltip>
                        </template>
                    </el-calendar>
                </div>
            </div>
        </el-drawer>
        <!-- 预约抽屉 -->
        <el-drawer
            :visible.sync="showRiliDrawer"
            :append-to-body="true"
            size="400px"
            :title="riliEditMode ? '编辑预约' : '预约车辆'"
        >
            <el-form ref="riliForm" class="rili-form" :model="riliData" :rules="riliRules" label-width="100px">
                <el-form-item label="车名称">
                    <el-input v-model="riliData.carName" disabled />
                </el-form-item>
                <el-form-item label="预约日期">
                    <el-input v-model="riliData.date" disabled />
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="riliData.name" />
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                    <el-input v-model="riliData.phone" />
                </el-form-item>
                <el-form-item label="备注" prop="beizhu">
                    <el-input v-model="riliData.beizhu" type="textarea" />
                </el-form-item>
                <div class="rili-action-btns">
                    <el-button v-if="riliEditMode" class="rili-delete-btn" @click="removeRiliOrder">删除</el-button>
                    <div class="rili-action-right">
                        <el-button type="primary" :loading="riliSubmitting" @click="submitRiliOrder">{{ riliEditMode ? '修改' : '提交' }}</el-button>
                    </div>
                </div>
            </el-form>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/yuyueche";
import Qu from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import ImageUpload from "@/components/Upload/image";
import VueUeditorWrap from 'vue-ueditor-wrap';
export default {
    data() {
        return {
            optionList: [],
            thumbList: [],
            queryParam: {
                commId: "",
                name: "",
                status: "",
                desc: "",
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
            viewData: {
                id: "",
                commId: "",
                name: "",
                che_xing: "",
                yanse: "",
                chejiahao: "",
                thumb: "",
                desc: "",
                content: "",
                status: 1,
            },
            rules: {
                commId: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入车牌号",
                        trigger: "blur",
                    },
                ],
            },
            showUpload: true,
            imageDefaultList: "",
            ueconfig: {
                // UEditor配置
                UEDITOR_HOME_URL: '/static/UEditor/',
                serverUrl: '/api/upload/ueditor',
                // 其他配置项
            },
            // 日历抽屉
            showCalendarDrawer: false,
            currentCar: null,
            calendarData: [],
            currentMonth: new Date(),
            calendarRequestSeq: 0,
            drawerRequestSeq: 0,
            // 预约抽屉
            showRiliDrawer: false,
            riliEditMode: false,
            riliSubmitting: false,
            riliData: {
                id: "",
                carId: "",
                carName: "",
                date: "",
                name: "",
                phone: "",
                beizhu: ""
            },
            riliRules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }]
            }
        };
    },
    components: {
        Pagination,
        VueUeditorWrap,
        ImageUpload,
    },
    created() {},
    mounted() {
        this.getList();
        this.getSelectCity();
    },
    watch: {
        currentMonth(val) {
            if (!val || !this.showCalendarDrawer || !this.currentCar) return;
            this.loadCalendarData(val);
        }
    },
    methods: {
        // 获取下拉列表
        getSelectCity() {
            Qu.select({}).then((res) => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            });
        },
        /**
         * @name: 更改状态
         * @param {*} val
         * @return {*}
         * @desc:
         */
        changeStatus(val) {
            let params = {
                id: val.id,
                status: val.status,
            };
            fetch.status(params).then((res) => {
                if (res.code == 200) {
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            if (status == 1) {
                // 成功
                this.showDrawer = false;
                this.getList();
            } else if (status == -1) {
                // 失败
                this.showDrawer = false;
            }
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            const requestSeq = ++this.drawerRequestSeq;
            this.resetForm();
            if (!obj.id) return;
            // 编辑
            fetch.detail({ id: obj.id }).then((res) => {
                if (requestSeq !== this.drawerRequestSeq || !this.showDrawer) return;
                if (res.code == 200) {
                    this.viewData = Object.assign({}, res.result, {
                        status: Number(res.result.status != null ? res.result.status : 1),
                    });
                    this.thumbList = this.viewData.thumb ? [this.viewData.thumb] : [];
                    // 设置图片默认列表
                    if (this.viewData.thumb) {
                        let thumb_arr = [];
                        thumb_arr.push({
                            name: this.viewData.thumb,
                            path: this.viewData.thumb,
                            url: this.$publicData.imgUrl + this.viewData.thumb,

                        });
                        // 回显图
                        this.imageDefaultList = JSON.stringify(thumb_arr);
                    } else {
                        this.imageDefaultList = "";
                    }
                }
            });
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc:
         */
        tijiao(formName) {
            let that = this;
            if(this.thumbList.length<1){
                this.$message.warning("请上传封面图")
                return
            } else {
                this.viewData.thumb = this.thumbList[0];
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.viewData.id) {
                        // 编辑
                        fetch.edit(this.viewData).then((res) => {
                            if (res.code == 200) {
                                that.$message.success(res.message);
                                that.onUpdateDrawer(1);
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                    } else {
                        // 新增
                        fetch.create(this.viewData).then((res) => {
                            if (res.code == 200) {
                                that.$message.success(res.message);
                                that.onUpdateDrawer(1);
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                    }
                } else {
                    this.$message.warning(this.$t("form.verifyMsg"));
                }
            });
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            if (this.$refs["ruleForm"]) {
                this.$refs["ruleForm"].resetFields();
                this.$refs["ruleForm"].clearValidate();
            }
            this.viewData = {
                id: "",
                commId: "",
                name: "",
                che_xing: "",
                yanse: "",
                chejiahao: "",
                thumb: "",
                desc: "",
                content: "",
                status: 1,
            };
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload && this.$refs.imageUpload.clearFileList) {
                this.$refs.imageUpload.clearFileList();
            }
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.drawerRequestSeq += 1;
            this.showDrawer = false;
            this.resetForm();
        },
        /**
         * @name: 处理图片上传更新
         * @param {Array} imgList
         * @return {*}
         * @desc:
         */
        onUpdateImg(val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            // 图片数据需要等到抽屉完全打开后才能传入组件，否则会有问题，所以放在nextTick里
            this.$nextTick(function () {
                that.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 重置查询条件 */
        resetSearch() {
            this.queryParam = {
                commId: "",
                name: "",
                status: "",
                desc: "",
                page: 1,
                size: 10,
            };
            this.getList();
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            fetch.list(that.queryParam).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        remove(row) {
            let that = this;
            that
                .$confirm("确定删除该内容吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
        // 打开日历抽屉
        openCalendarDrawer(row) {
            this.currentCar = row;
            this.showCalendarDrawer = true;
            this.loadCalendarData();
        },
        // 关闭日历抽屉
        closeCalendarDrawer() {
            this.showCalendarDrawer = false;
            this.currentCar = null;
            this.calendarData = [];
        },
        // 加载日历数据
        loadCalendarData(targetMonth) {
            if (!this.currentCar) return;
            const queryMonth = targetMonth || this.currentMonth;
            const year = queryMonth.getFullYear();
            const month = queryMonth.getMonth() + 1;
            const requestSeq = ++this.calendarRequestSeq;
            fetch.riqidata({
                    cheId: this.currentCar.id,
                    year: year,
                    month: month
            }).then((res) => {
                if (requestSeq !== this.calendarRequestSeq) return;
                if (res.code == 200) {
                    this.calendarData = res.result.list || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 上个月
        prevMonth() {
            const prev = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
            this.currentMonth = prev;
        },
        // 下个月
        nextMonth() {
            const next = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
            this.currentMonth = next;
        },
        // 判断是否已预约 判断calendarData中是否有对应日期的数据，如果有则表示已预约
        isBooked(day) {
            // calendarData中的日期数据appointment_date 格式化为"YYYY-MM-DD"，在与day进行比较   
            return this.calendarData.some(item => this.normalizeCalendarDay(item.appointment_date || item.date) === day);
        },
        getBookedInfo(day) {
            return this.calendarData.find(item => this.normalizeCalendarDay(item.appointment_date || item.date) === day) || null;
        },
        normalizeCalendarDay(day) {
            if (!day) return "";
            return String(day).split(" ")[0].split("T")[0];
        },
        getAppointmentField(record, fields) {
            if (!record) return "--";
            const field = fields.find(key => record[key] !== undefined && record[key] !== null && record[key] !== "");
            return field ? record[field] : "--";
        },
        getBookedName(day) {
            return this.getAppointmentField(this.getBookedInfo(day), ["name", "userName", "appointment_name"]);
        },
        getBookedPhone(day) {
            return this.getAppointmentField(this.getBookedInfo(day), ["contact", "phone", "mobile"]);
        },
        getBookedRemark(day) {
            return this.getAppointmentField(this.getBookedInfo(day), ["beizhu", "remark", "remarks", "appointment_remark"]);
        },
        getBookedId(day) {
            return this.getAppointmentField(this.getBookedInfo(day), ["id", "riliId", "appointment_id"]);
        },
        // 仅当前月显示预约状态信息
        isCurrentMonthCell(data) {
            return data && data.type === 'current-month';
        },
        isUnavailableDay(day, data) {
            return this.isCurrentMonthCell(data) && !this.isBooked(day) && this.isPastDay(day);
        },
        isAvailableDay(day, data) {
            return this.isCurrentMonthCell(data) && !this.isBooked(day) && !this.isPastDay(day);
        },
        handleDayCellClick(data) {
            if (!this.isCurrentMonthCell(data)) return;
            const day = data.day;
            if (this.isBooked(day)) {
                this.openRiliDrawer(day, true);
                return;
            }
            if (!this.isAvailableDay(day, data)) return;
            this.openRiliDrawer(day, false);
        },
        // 判断是否为今天之前日期
        isPastDay(day) {
            const targetDate = new Date(`${day} 00:00:00`);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return targetDate < today;
        },
        openRiliDrawer(day, isEdit = false) {
            if (!isEdit && this.isPastDay(day)) {
                this.$message.warning("今天之前的日期不可预约");
                return;
            }
            this.riliEditMode = isEdit;
            const bookedInfo = isEdit ? this.getBookedInfo(day) : null;
            this.riliData.carId = this.currentCar.id;
            this.riliData.carName = this.currentCar.name;
            this.riliData.date = day;
            this.riliData.id = bookedInfo ? this.getBookedId(day) : "";
            this.riliData.name = bookedInfo ? this.getBookedName(day) : "";
            this.riliData.phone = bookedInfo ? this.getBookedPhone(day) : "";
            this.riliData.beizhu = bookedInfo ? this.getBookedRemark(day) : "";
            this.riliSubmitting = false;
            this.showRiliDrawer = true;
        },
        submitRiliOrder() {
            if (this.riliSubmitting) return;
            this.$refs.riliForm.validate(valid => {
                if (!valid) return;
                this.riliSubmitting = true;
                const params = {
                    id: this.riliData.id,
                    cheId: this.riliData.carId,
                    date: this.riliData.date,
                    name: this.riliData.name,
                    phone: this.riliData.phone,
                    contact: this.riliData.phone,
                    beizhu: this.riliData.beizhu
                };
                const submitApi = this.riliEditMode ? fetch.editRiliOrder : fetch.createRiliOrder;
                submitApi(params).then(res => {
                    if (res.code === 200) {
                        this.$message.success(this.riliEditMode ? "修改成功" : "预约成功");
                        this.showRiliDrawer = false;
                        this.riliEditMode = false;
                        this.loadCalendarData();
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(() => {
                    this.$message.error("提交失败，请稍后重试");
                }).finally(() => {
                    this.riliSubmitting = false;
                });
            });
        },
        removeRiliOrder() {
            if (!this.riliData.id) {
                this.$message.warning("缺少预约ID，无法删除");
                return;
            }
            this.$confirm("确定删除该预约吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                fetch.removeRiliOrder({
                    id: this.riliData.id,
                    cheId: this.riliData.carId,
                    date: this.riliData.date
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success("删除成功");
                        this.showRiliDrawer = false;
                        this.riliEditMode = false;
                        this.loadCalendarData();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }).catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}

.search-div {
    margin-bottom: 20px;
    padding: 15px;
    background: #fff;
    border-radius: 4px;
}

.search-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.search-buttons .el-button {
    flex: none;
}

/* Table样式优化 */
.custom-table {
    border-radius: 4px;
    overflow: hidden;
}

.custom-table ::v-deep .el-table__header th {
    background-color: #f5f7fa !important;
    color: #606266 !important;
    font-weight: bold !important;
    border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .el-table__row {
    border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .el-table__row:last-child {
    border-bottom: none;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .search-div {
        padding: 10px;
    }

    .search-buttons {
        justify-content: flex-start;
        margin-top: 10px;
    }

    .search-buttons .el-button {
        margin-bottom: 5px;
    }

    .custom-table {
        font-size: 12px;
    }

    .custom-table ::v-deep .el-table__header th,
    .custom-table ::v-deep .el-table__row td {
        padding: 8px 4px;
    }
}

/* 日历样式 */
.calendar-container {
    padding: 20px;
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.current-month {
    font-size: 18px;
    font-weight: bold;
}

.calendar-day {
    text-align: center;
    min-height: 72px;
    padding: 6px 4px;
    border-radius: 6px;
}

.calendar-day-clickable {
    cursor: pointer;
}

.calendar-day-clickable:hover {
    background: #f5f9ff;
}

.booked {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
}

.calendar-booked-tooltip-content {
    line-height: 1.8;
    min-width: 180px;
}

.rili-action-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}

.rili-action-right {
    margin-left: auto;
}

.rili-form {
    margin-right: 12px;
}

.rili-delete-btn {
    background: #fff;
    color: #303133;
    border-color: #dcdfe6;
    margin-left: 10px;
}

.rili-delete-btn:hover,
.rili-delete-btn:focus {
    background: #fff;
    color: #303133;
    border-color: #c0c4cc;
    margin-left: 10px;
}

.available {
    color: #67c23a;
    font-size: 12px;
    margin-top: 5px;
}

.unavailable {
    color: #909399;
    font-size: 12px;
    margin-top: 5px;
}
</style>
